/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Recommended products Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/
	(function ProductRecommmendedModule() {
		function HandleCartShippingQuoteResponse({$recommendedContentEle, $recommendedResponseEle}) {
			return function (evt, response) {
				if (response) {
					$recommendedContentEle.addClass('has-recommendations');
					$recommendedResponseEle.html(response);
				} else {
					$recommendedContentEle.addClass('no-recommendations');
					return;
				}

				const displayList = $recommendedContentEle.data('display-list');
				if(displayList) {
					// Reattach Add To Cart Button Events
					var cartEle = rp$('.search-listing-module').find('.add-to-cart.enabled');
					if (typeof cartEle.add_to_cart === 'function') {
						cartEle.add_to_cart();
					}
				} else {
					var $product_recommendations = $recommendedResponseEle.find('.recommendations');
					var $eachProductRecommended = rp$('.each-recommended-products');
					const carouselWidth = $product_recommendations.width();
					var itemsCount = $product_recommendations.find('.recommendation').length;
					const responsiveRules = {
						0: {
							items: 2
						},
					};

					if(carouselWidth < 350){
						responsiveRules[350] = {
							items: Math.min(itemsCount, 1),
						};
					}

					if(carouselWidth > 450){
						responsiveRules[500] = {
							items: Math.min(itemsCount, 4),
						};
					}

					if(carouselWidth > 750){
						responsiveRules[800] = {
							items: Math.min(itemsCount, 8),
						};
					}

					$eachProductRecommended.ready(function(){
						var cartEle = $eachProductRecommended.find('.add-to-cart.enabled')
						if (typeof cartEle.add_to_cart === 'function') {
							cartEle.add_to_cart();
						}
					});
					$product_recommendations.addClass('owl-carousel').owlCarousel({
						margin: 10,
						nav: true,
						navText: false,
						responsive: responsiveRules,
					});
				}
			};
		}

		$onReady({
			rp$, window,
			label: 'product_recommended',
			fn: function () {
				var $product_recommended_modules = rp$('.product-recommended-module');

				const handleUnobserve = (element) => {
					observer.unobserve(element);
				};

				const handleIntersect = (intersects) => {
					for (let i=0; i < intersects.length; i++) {
						const item = intersects[i];
						if (item.intersectionRatio > 0) {
							const moduleEle = item.target;
							handleUnobserve(moduleEle);
							loadProductRecommendations(moduleEle);
						}
					}
				};

				const loadProductRecommendations = (moduleEle) => {
					const moduleInner = moduleEle.querySelector('.product-recommendations');

					rp$(document).trigger('productGetRecommendations:request', {
						catalog: moduleInner.dataset.catalog,
						skuStripped: moduleInner.dataset.skuStripped,
						recommendationLimit: moduleInner.dataset.recommendationLimit,
						displayList: moduleInner.dataset.displayList,
						addToCartContent: moduleInner.dataset.addToCartContent,
					});
				};

				let observer = null;
				if ('IntersectionObserver' in window) {
					observer = new IntersectionObserver(handleIntersect, {
						root: null,
						rootMargin: '0px',
						threshold: 0,
					});
					document.querySelectorAll('.product-recommended-module').forEach((element) => {
						observer.observe(element);
					});
				} else {
					const module = document.querySelector('.product-recommended-module');
					if (module) {
						loadProductRecommendations(module);
					}
				}

				rp$.each($product_recommended_modules, function DropDownMenu_Iterator(idx, product_recommended_module) {
					var $recommendedContentEle = rp$(product_recommended_module).find('.product-recommendations');
					var $recommendedResponseEle = rp$(product_recommended_module).find('.recommended-products-response');

					const eventHandler = HandleCartShippingQuoteResponse({
						$recommendedContentEle,
						$recommendedResponseEle,
					});

					/* Handle Recommendation Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off('productGetRecommendations:response', eventHandler);
					rp$(document).on('productGetRecommendations:response', eventHandler);
				}); // END rp$.each module
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
